import { memo } from 'react';

import {
  useCanvasDeleteShortcut,
  useChatSidebarShortcut,
  useClipboardShortcuts,
  useFlattenShortcut,
  useGroupShortcuts,
  useLayerShortcuts,
  useRenameShortcut,
  useToolShortcuts,
  useZoomShortcuts,
} from '../hooks/shortcuts';

/**
 * Renderless component that registers the canvas's global keyboard shortcuts.
 *
 * Must be rendered inside `<ReactFlow>` unconditionally (not gated on the
 * empty/null canvas state) — clipboard paste is one of the ways content gets
 * added to an empty canvas, so its shortcut must stay registered even while
 * the bottom toolbar (which used to own these hooks) is hidden.
 */
export const CanvasShortcuts = memo(() => {
  useCanvasDeleteShortcut();
  useChatSidebarShortcut();
  useClipboardShortcuts();
  useFlattenShortcut();
  useGroupShortcuts();
  useToolShortcuts();
  useLayerShortcuts();
  useRenameShortcut();
  useZoomShortcuts();

  return null;
});

CanvasShortcuts.displayName = 'CanvasShortcuts';
